import {useState} from 'react'
import EInvoiceParameterSection from './EInvoiceParameterSection'
import IyzicoOptionSection from './IyzicoOptionSection'

type ActiveTab = 'iyzico' | 'einvoice'

function CredentialSettingsPage() {
  const [activeTab, setActiveTab] = useState<ActiveTab>('iyzico')

  return (
    <div className='card card-stretch'>
      <div className='card-header'>
        <h3 className='card-title'>Entegrasyon Ayarları</h3>
      </div>
      <div className='card-body py-5'>
        <ul className='nav nav-tabs nav-line-tabs nav-stretch fs-4 fw-bold border-0 mb-5'>
          <li className='nav-item'>
            <a
              className={`nav-link ${activeTab === 'iyzico' ? 'active' : ''}`}
              onClick={() => setActiveTab('iyzico')}
              role='button'
            >
              Iyzico
            </a>
          </li>
          <li className='nav-item'>
            <a
              className={`nav-link ${activeTab === 'einvoice' ? 'active' : ''}`}
              onClick={() => setActiveTab('einvoice')}
              role='button'
            >
              E-Fatura
            </a>
          </li>
        </ul>

        {activeTab === 'iyzico' && <IyzicoOptionSection />}
        {activeTab === 'einvoice' && <EInvoiceParameterSection />}
      </div>
    </div>
  )
}

export default CredentialSettingsPage
